// extracted by mini-css-extract-plugin
module.exports = {"Slice404":"styles_Slice404__jxtzn","texts":"styles_texts__alTOs","text":"styles_text__ZwIMu","cta":"styles_cta__vzjUc"};